var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.96 96.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444444;}.cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10.27S-.76,0,8.91,0h77.9S97-.6,97,9V89.45s0,7.5-9.3,7.5H11.05S0,97.44,0,86.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.25,62.39s-22.79-.78-22.82-23.24c0,0,0-8.75,4.54-13.32a24.08,24.08,0,0,1,0-13.71s6.85-2.29,13.71,4.57c0,0,13.71-4.57,25.13,0,0,0,6.85-6.86,13.71-4.57,0,0,4.57,6.85,2.28,11.42,0,0,9.14,6.86,4.57,22.85,0,0-4.57,18.28-23.65,16,0,0,5.37,4.57,5.37,13.7V87.52c0,2.28-20.43,2.28-27.35,0l1.08-10.28s0-2.29-2.29,0-11.42,0-13.71-6.86c0,0-4.57-6.85-9.14-9.14s6.86-4.57,11.43,4.57c0,0,6.85,6.86,13.71,2.29C38.82,68.1,38.82,65.81,42.25,62.39Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubGray);
export default __webpack_public_path__ + "static/media/github-gray.022cc22e.svg";
export { ForwardRef as ReactComponent };